import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import {
  Button,
  ListItemIcon,
  Menu,
  MenuItem,
} from '@mui/material';

interface FileItemProps {
  index: number;
  fileName: string;
  setSelectedIndex: (index: number) => void;
  openEditModal: () => void;
  openDeleteModal: () => void;
}

const FileItem = ({
  index,
  fileName,
  setSelectedIndex,
  openEditModal,
  openDeleteModal,
}: FileItemProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // functions
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <tr>
        <td className="text-center">{index}</td>
        <td className="col-9">{fileName}</td>
        <td className="table-action text-center">
          <div className="btn-group btn-group-sm">
            <Button
              type="button"
              className="btn btn-outline-secondary dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={handleClick}
            >
              操作を選択
            </Button>
            <div className="dropdown-menu">
              <a className="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#itemeditModal">
                <i className="fa-solid fa-pen-to-square fa-fw" />
                編集
              </a>
              <a className="dropdown-item text-danger" href="#" data-bs-toggle="modal" data-bs-target="#itemDeleteModal">
                <i className="fa-solid fa-trash fa-fw" />
                削除
              </a>
            </div>
          </div>
        </td>
      </tr>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClick={handleClose}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => { setSelectedIndex(index - 1); openEditModal(); }} style={{ color: '#212529' }}>
          <ListItemIcon>
            <FontAwesomeIcon color="#212529" icon={faEdit} fontSize="small" />
          </ListItemIcon>
          編集
        </MenuItem>
        <MenuItem onClick={() => { setSelectedIndex(index - 1); openDeleteModal(); }} className="text-danger">
          <ListItemIcon>
            <FontAwesomeIcon className="text-danger" icon={faTrashCan} fontSize="small" />
          </ListItemIcon>
          削除
        </MenuItem>
      </Menu>

    </>
  );
};

export default FileItem;
